import React from 'react';
import { InfoBlock, Icon } from '@picsio/ui';
import { Info } from '@picsio/icons';
import l10n from '../../../shared/strings';
import styles from './styles.module.scss';

const MobileUploadWarning = () => (
  <InfoBlock
    className={styles.info}
    icon={() => <Info />}
  >
    {l10n.IMPORT.textDoNotCloseAppWhileUploading}
  </InfoBlock>
);

export default MobileUploadWarning;
